<template>
    <transition appear name="slide-fade-bottom" v-bind="$attrs">
        <div
            v-if="visible"
            data-dialog="true"
            class="fixed w-screen bottom-0 left-0 right-0"
            :class="'z-' + zindex"
        >
            <slot></slot>
        </div>
    </transition>
</template>
<style scoped>
.slide-fade-bottom-enter-active {
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-bottom-leave-active {
    transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.slide-fade-bottom-enter-from,
.slide-fade-bottom-leave-to {
    transform: translateY(100%);
    opacity: 0;
}
</style>
<script>
export default {
    name: "bottom-drawer-transition-component",
    inheritAttrs: false,
    props: {
        component: {
            type: Object,
            required: false,
        },
        visible: {
            type: Boolean,
            required: true,
        },
        zindex: {
            type: Number,
            required: true,
        },
    },
};
</script>
